import { cx } from '@linaria/core';
import { omit } from 'rambda';
import { flex } from 'styles/utils/core';
import { ReactNode } from 'react';
import { Tooltip } from 'components/PlatformResourceSelector/Tooltip';
import { TooltipInitialState } from 'reakit/ts';

export interface TextTooltipProps extends React.HTMLAttributes<HTMLSpanElement> {
  initialState?: TooltipInitialState;
  text: ReactNode;
  showArrow?: boolean;
  contentProps?: React.HTMLAttributes<HTMLDivElement>;
  className?: string | undefined;
  hidden?: boolean;
}

export const TextTooltip = ({
  className,
  initialState,
  text,
  children,
  showArrow,
  contentProps = {},
  hidden,
  ...rest
}: TextTooltipProps): JSX.Element => (
  <Tooltip
    hidden={hidden}
    showArrow={showArrow}
    initialState={initialState}
    aria-label={typeof text === 'string' ? text : ''}
    text={
      <div className={cx(className)} {...rest}>
        {text}
      </div>
    }
    {...rest}
  >
    <div className={cx(flex.init, flex.justifyContent.center, flex.alignItems.center, contentProps.className)} {...omit(['className'], contentProps)}>
      {children}
    </div>
  </Tooltip>
);
